// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__10bS4","modalFooterButton":"ModalNotes_modalFooterButton__p-c5i"};